import React, { useState } from "react";
import { Tooltip } from 'antd';
import styles from "./scss/automatedMints.module.scss";
import noDataStyle from "../../leftsidebar/noCalls/noCalls.module.scss";
import { URButton } from '../../../../shared/widgets/button';
//*import { URCheckBox } from '../../../../shared/widgets/checkbox';
//import { URRadio } from '../../../../shared/widgets/radiobox';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // ES6
//*import iconxls from "../../../../styles/images/grid_xls.svg";
//*import { URInput } from '../../../../shared/widgets/input';
import store from "../../../../context/store/store";
import { callActionChanges, currentTimer, getCurrentCallDetail } from "../../../../base/callService/common";
import { AttachedFiles } from "./attachedfile";
import { AddKeywords } from "./addkeywords";
import _ from "lodash";
import { StoreEditAutomatedMinutes } from "../../../../base/callService/asrTTS";
import { init_ASR } from "../../../../models/callModel";
import { useSelector } from "react-redux";
//*import { contactService } from "../../../../base/contactService";
import { Highlights } from "./highlight";
import { DownloadFile } from "./downloadFile";
//*import { Types } from "../../../../context/action/action";
import Lottie from 'lottie-react';
import groovyWalkAnimation from "../../../../styles/images/chat blank state loading.json";

type TranscriptContainerState = {
  isShareTranscript: boolean;
  isEdit: boolean;
  editautomated:any;
}
export default function AutomatedMints(this: any) {

  const [scriptInfo, setScriptInfo] = useState<TranscriptContainerState>
  ({ isShareTranscript: false, isEdit: false, editautomated: {} });
  const { closeCaption }:init_ASR = useSelector((state:init_ASR) => state);

  

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      // [{size: []}],
      ['bold', 'italic','blockquote', 'strike','link'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ]
  };

  // const modules1 = {
  //   toolbar: {
  //     container: [
  //       ["bold", "italic", "underline", "strike"],
  //       [
  //         { list: "ordered" },
  //         { list: "bullet" },
  //         { align: "right" }
  //       ],
  //       ["link", "image"]

  //     ]
  //   },
  //   clipboard: { matchVisual: false }
  // };

  const formats = [
    "bold",
    "italic",
    "blockquote",
    "strike",
    "size",
    "list",
    "bullet",
    "link",
    "image",
    "align",
    "color",
    "background"
  ];
  const handleChange =  _.debounce((content:any, delta:any, source:any, editor:any) => {
    const getHTML = editor.getHTML();
    let text = getHTML;
    text = text.replace(/<\/li>/gi, " || ");
    text = text.replace(/<[^>]+>/g, '');
    //StoreEditAutomatedMinutes(text);
    setScriptInfo({ ...scriptInfo, editautomated: text});
    
  }, 1000);
  
  const storeConversationClick = () => {
    if (closeCaption.editautomatedmins.length > 0) {
      let { isEdit, editautomated } = scriptInfo;
      if (!isEdit) {
        setScriptInfo({ ...scriptInfo, isEdit: true });
        if (editautomated.length !== undefined) {
          let strx = editautomated.split('||');
          let array: any = [];
          strx.forEach(function(obj: any) {
            array.push({
              text: obj
            });
          });
          let editData = array.splice(0, array.length - 1);
          StoreEditAutomatedMinutes(editData);
        }
      }
    }
  };

  const setSharescript = () => { callActionChanges('summaryShare'); };

  let loggedUserDetails: any = store.getState().loginReducer.userdetails || [];
  let selfName: string = loggedUserDetails['caller_id'] || "Unknown";
  let participantName: string = "Unknown";
  let { particularLog }: any = store.getState().callReducer||[];
  let activeCallDetail: any = getCurrentCallDetail();
  if (closeCaption.asrCallingFrom === 'callList') {
    let userData: any = activeCallDetail.contact || [];
    participantName = userData['caller_id'] || activeCallDetail[ "caller_id"];
  }
  else {
    participantName = particularLog['caller_id'] || activeCallDetail[ "caller_id"];
  }

  return (
    <>
      <div className={`${styles.chatDialPadContainer} animate__animated animate__fadeIn animate__faster`}>
        <div className={styles.chatsharefile}>
          <div className={styles.topHeaderShareSec}>
            <h4>Automated Minutes </h4>
            <ul>
              <li>
                
                  <AttachedFiles></AttachedFiles>
              </li>
              <li>
                <Tooltip placement="topRight" title="Add Document">
                  <AddKeywords ></AddKeywords>
                </Tooltip>
              </li>
              {closeCaption.editautomatedmins.length !== 0 &&
                <li>
                  <Tooltip placement="topRight" title="Download">
                    <DownloadFile />
                  </Tooltip>
                </li>
              }
            </ul>
          </div>
        
          <div className={styles.topinnerSecCon}>
            <div className={styles.meetingSummaryContainer}>
              {/* <div className={styles.meetingRecordTitle}>Recorded language</div>
              <div className={styles.shareSelect}>
                <Dropdown overlay={outPutLangSelection} placement="bottomRight" trigger={['click']}>
                  <div className={styles.langSelSec}>
                    <span>Global English (en) - Default</span>
                    <span className="icon_downarrow2"></span>
                  </div>
                </Dropdown>
              </div> */}
               
              <div className={styles.meetingRecordSummary}>Meeting Summary</div>
              <div className={styles.meetingPersonName}>{selfName},{participantName}</div>
              <div className={styles.meetingDetails}>
                <span className={styles.meetingTime}>
                  {currentTimer().date +' '+ currentTimer().month +
                    ' '+ currentTimer().year +' • '+ currentTimer().time+' '+currentTimer().amPm}</span>
                <div className={styles.meetingGroups}>
                  {/* <li>3</li> */}
                  <li>
                    <div className={styles.users}>{ (selfName?.charAt(0)).toUpperCase()}</div>
                    <div className={styles.users}>{ (participantName?.charAt(0)).toUpperCase() }</div>
                  </li>
                </div>
              </div>
            </div>
            <div className={styles.notestopbarsec}>
              
              {closeCaption.editautomatedmins.length !== 0 &&!closeCaption.isTranscriptLoading?
                <div className={styles.newpdf} onDoubleClick={() => storeConversationClick()}>
                  <div id="editorText" className="scrollerhover">

                    {/* {closeCaption.editautomatedmins.map((elem: any, index: any) => {
                    return (<>
                      <div className={styles.transcriptuserList} key={index}>
                        <div className={styles.transcriptText}>
                          <Highlights searchWords={closeCaption.keywords}>{elem.text}</Highlights>
                        </div>
                      </div>
                    </>);
                  })} */}
                    <ReactQuill
                      placeholder={'Enter description'}
                      formats={formats}
                      modules={modules}
                      theme="snow"
                      readOnly={false}
                      onChange={(content: any, delta: any, source: any, editor: any) =>
                        handleChange(content, delta, source, editor)}
                    >
                      <div id="editor" onDoubleClick={() => storeConversationClick()}>
                      

                        {closeCaption.editautomatedmins.map((elem: any, index: any) => {
                          return (<>
                            <div className={styles.transcriptuserList} key={index}>
                              <div className={styles.transcriptText}>
                                <Highlights searchWords={closeCaption.keywords}>{elem.text}</Highlights>
                              </div>
                            </div>
                          </>);
                        })}
                      </div>
                    </ReactQuill>

                 
                  </div>
                </div>
         
                :
                (closeCaption.isTranscriptLoading) ?

                  <div className={noDataStyle.noMessage}>
                      
                    <div ><Lottie className="svgLoadinglistcenter" animationData={groovyWalkAnimation} /></div>
                  </div> :
                
                  <div className={noDataStyle.noMessage}>
                    <div className={noDataStyle.noMessageinner}>
                      <p className={noDataStyle.noMessageTitle}>No Keyword Found</p>
                      <div className={noDataStyle.recentBtn}>
                        <span className="icon_outlineleftarrow"></span>
                        <span onClick={() => callActionChanges('summary')}>no detail</span>
                      </div>
                    </div>
                  </div>
              
              }


              {/* <ReactQuill
                placeholder={'Enter description'}
                formats={formats}
                modules={modules}
                theme="snow"
                readOnly={false}
                onChange={(content:any, delta:any, source:any, editor:any)=>
                  handleChange(content, delta, source, editor)}
              >
                <div id="editor" onDoubleClick={()=>storeConversationClick()}>
                  {closeCaption.editautomatedmins && closeCaption.editautomatedmins.map((elem: any, index: any) => {
                    return (<>
                      <Highlights searchWords={closeCaption.keywords}>{elem.text}</Highlights>
                    </>);
                  })}
                </div>
              </ReactQuill> */}
              {/* <ReactQuill theme="snow" className="autoCustomHeightSet"></ReactQuill> */}
            </div>
          </div>
          <div className={styles.chatfooterbtn}>
            <URButton className={styles.chatcancelbtn} onClick={()=>callActionChanges('summary')} name='Cancel' />
            <URButton className={closeCaption.editautomatedmins.length === 0 ?
              styles.chatSharebtnDisable : styles.chatSharebtn} name='Share'
            onClick={setSharescript} />
          </div>
        </div>
      </div>
    </>
  );
};

